import React from "react";
import PropTypes from "prop-types";

import _ from "lodash";
import "./style.scss";

const UserPersonalParamItem = ({ title, value }) => {
  if (_.isEmpty(value)) return null;

  return (
    <div className="personal-info__param">
      <b>{title}:</b> {value}
    </div>
  );
};

UserPersonalParamItem.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
};

export default UserPersonalParamItem;
